import { createModel } from '@rematch/core';
import { RootModel } from '../root';
import { ContractsState } from './contracts.model';
import reducers from './contracts.reducers';
import effects from './contracts.effects';

const initialState: ContractsState = {
  contracts: null,
  totalDebtAmountOnAllContractsByCurrency: null
};

const contractsModel = createModel<RootModel>()({
  state: initialState,
  reducers,
  effects
});

export default contractsModel;
